// Floating icons with sarcastic financial humor
export const floatingIcons = [
  { id: 1, emoji: '💸', message: 'Algún día...', x: 10, y: 20, duration: 25, delay: 0 },
  { id: 2, emoji: '🤑', message: 'Mañana empiezo', x: 85, y: 15, duration: 30, delay: 3 },
  { id: 3, emoji: '💰', message: 'Me lo merezco', x: 20, y: 60, duration: 28, delay: 6 },
  { id: 4, emoji: '🏦', message: 'Después de...', x: 75, y: 50, duration: 32, delay: 9 },
  { id: 5, emoji: '📉', message: 'Solo uno más', x: 45, y: 30, duration: 27, delay: 12 },
  { id: 6, emoji: '🎰', message: 'YOLO', x: 60, y: 70, duration: 29, delay: 15 },
  { id: 7, emoji: '💳', message: 'Sin intereses', x: 30, y: 80, duration: 26, delay: 18 },
  { id: 8, emoji: '🍕', message: 'Es poco...', x: 90, y: 40, duration: 31, delay: 21 },
  { id: 9, emoji: '☕', message: 'Solo $50', x: 15, y: 45, duration: 28, delay: 24 },
  { id: 10, emoji: '🛍️', message: 'Está en oferta', x: 70, y: 25, duration: 30, delay: 27 },
  { id: 11, emoji: '🎮', message: 'Un gustito', x: 40, y: 55, duration: 29, delay: 30 },
  { id: 12, emoji: '🍺', message: 'La última', x: 55, y: 10, duration: 27, delay: 33 },
  { id: 13, emoji: '📱', message: 'Necesito el nuevo', x: 25, y: 35, duration: 28, delay: 36 },
  { id: 14, emoji: '👟', message: 'Están baratos', x: 80, y: 65, duration: 26, delay: 39 },
  { id: 15, emoji: '🎉', message: 'Me lo gasto', x: 50, y: 85, duration: 30, delay: 42 }
];

// Logo icons for subtle brand presence
export const brandLogos = [
  { id: 1, letter: 'Q', x: 5, y: 10, size: 30, rotation: 15, duration: 40, delay: 0 },
  { id: 2, letter: 'Q', x: 92, y: 30, size: 25, rotation: -20, duration: 45, delay: 10 },
  { id: 3, letter: 'Q', x: 8, y: 70, size: 28, rotation: 10, duration: 42, delay: 20 },
  { id: 4, letter: 'Q', x: 88, y: 80, size: 32, rotation: -15, duration: 38, delay: 30 }
];
